

// let first_frame = document.querySelector('.frame1')
// let second_frame = document.querySelector('.frame2')
// let third_frame = document.querySelector('.frame3')
// let fourth_frame = document.querySelector('.frame4')

// let first_frame_button = document.querySelector('.frame1 .pop-btn')
// let second_frame_button = document.querySelector('.frame2 .pop-btn')
// let third_frame_button = document.querySelector('.frame3 .pop-btn')
// let reset_frame_button = document.querySelector('.frame4 .retake')

// // if(document.querySelector('.frame4 .addcart')) {
// //   add_to_cart_button = document.querySelector('.frame4 .addcart')
// // }

// // let second_frame_select = document.querySelector('.size-second')
// let selected_first = 0
// let selected_second = 0

// let _sizelist = [
//   [4,4,6,6,8,8,10,10,12,12,14,14],
//   [4,6,6,8,8,10,10,12,12,14,14,16],
//   [6,6,8,8,10,10,12,12,14,14,16,16],
//   [8,8,8,10,10,12,12,14,14,16,16,18],
//   [10,10,10,10,12,12,14,14,16,16,18,18],
//   [12,12,12,12,12,14,14,16,16,18,18,20],
//   [14,14,14,14,14,14,16,16,18,18,20,20],
//   [16,16,16,16,16,16,16,18,18,20,20,22],
//   [18,18,18,18,18,18,18,18,20,20,22,22],
//   [20,20,20,20,20,20,20,20,20,22,22,24],
//   [22,22,22,22,22,22,22,22,22,22,24,24],
//   [24,24,24,24,24,24,24,24,24,24,24,26]
// ];

// if(document.querySelector('.find-fit')) {
//   document.querySelector('.find-fit').addEventListener('click', function() {
//     document.querySelector('.find-size-container').classList.add('active')
//   })
// }

// document.querySelector('.find-size-container .close').addEventListener('click', function() {
//   document.querySelector('.find-size-container').classList.remove('active')
// })

// first_frame_button.addEventListener('click', function() {
//   first_frame.classList.remove('active')
//   second_frame.classList.add('active')
// })

// second_frame_button.addEventListener('click', function() {
//   if(document.querySelector('.size-second').value != '') {
//     selected_first = parseInt(document.querySelector('.size-second').value)
//     second_frame.classList.remove('active')
//     third_frame.classList.add('active')
//   }
// })

// third_frame_button.addEventListener('click', function() {
//   if(document.querySelector('.size-third').value != '') {
//     selected_second = parseInt(document.querySelector('.size-third').value)
//     document.querySelector('.customers-size').textContent = `AU ${_sizelist[selected_first][selected_second]}`
//     third_frame.classList.remove('active')
//     fourth_frame.classList.add('active')
//     console.log(_sizelist[selected_first][selected_second])
//   }
// })

// reset_frame_button.addEventListener('click', function() {
//   fourth_frame.classList.remove('active')
//   first_frame.classList.add('active')
// })

// if(document.querySelector('.frame4 .addcart')) {
//   add_to_cart_button = document.querySelector('.frame4 .addcart')
  
//   add_to_cart_button.addEventListener('click', function() {
//     document.querySelector('.find-size-container').classList.remove('active')
//     fourth_frame.classList.remove('active')
//     first_frame.classList.add('active')

//     document.querySelector('[name="options[Size]"]').value = _sizelist[selected_first][selected_second];
//     document.querySelector('.additional-options').value = _sizelist[selected_first][selected_second];

//     const variant_picker = document.querySelector('.additional-options');
//     const variant_picker_id = variant_picker.options[variant_picker.selectedIndex].getAttribute('id');

//     document.querySelector('.product__info-wrapper .product-variant-id').value = variant_picker_id;
//     document.querySelector('.product__info-wrapper .product-form__submit').click()

//     // cstm start
//     const popup_btn = document.querySelector(".product_find_size");
//     popup_btn.classList.add("hidden");
//     document.body.classList.remove("no-scroll");
// console.log("kkkkk");
//   })
// }





// ####################  New SCRIPT ####################

document.addEventListener('DOMContentLoaded', function() {

  let _sizelist = [
    [4,4,6,6,8,8,10,10,12,12,14,14],
    [4,6,6,8,8,10,10,12,12,14,14,16],
    [6,6,8,8,10,10,12,12,14,14,16,16],
    [8,8,8,10,10,12,12,14,14,16,16,18],
    [10,10,10,10,12,12,14,14,16,16,18,18],
    [12,12,12,12,12,14,14,16,16,18,18,20],
    [14,14,14,14,14,14,16,16,18,18,20,20],
    [16,16,16,16,16,16,16,18,18,20,20,22],
    [18,18,18,18,18,18,18,18,20,20,22,22],
    [20,20,20,20,20,20,20,20,20,22,22,24],
    [22,22,22,22,22,22,22,22,22,22,24,24],
    [24,24,24,24,24,24,24,24,24,24,24,26]
  ];

  // For every .find-size-container block
  document.querySelectorAll('.find-size-container').forEach(container => {
    let first_frame = container.querySelector('.frame1');
    let second_frame = container.querySelector('.frame2');
    let third_frame = container.querySelector('.frame3');
    let fourth_frame = container.querySelector('.frame4');

    let first_frame_button = container.querySelector('.frame1 .pop-btn');
    let second_frame_button = container.querySelector('.frame2 .pop-btn');
    let third_frame_button = container.querySelector('.frame3 .pop-btn');
    let reset_frame_button = container.querySelector('.frame4 .retake');
    let add_to_cart_button = container.querySelector('.frame4 .addcart');
    let find_fit_button = container.closest('.find-fit-wrapp-product')?.querySelector('.find-fit');

    let selected_first = 0;
    let selected_second = 0;

    if (find_fit_button) {
      find_fit_button.addEventListener('click', function() {
        container.classList.add('active');
      });
    }

    const close_btn = container.querySelector('.close');
    if (close_btn) {
      close_btn.addEventListener('click', function() {
        container.classList.remove('active');
      });
    }

    first_frame_button?.addEventListener('click', function() {
      first_frame.classList.remove('active');
      second_frame.classList.add('active');
    });

    second_frame_button?.addEventListener('click', function() {
      const sizeSecond = container.querySelector('.size-second');
      if (sizeSecond && sizeSecond.value !== '') {
        selected_first = parseInt(sizeSecond.value);
        second_frame.classList.remove('active');
        third_frame.classList.add('active');
      }
    });

    third_frame_button?.addEventListener('click', function() {
      const sizeThird = container.querySelector('.size-third');
      if (sizeThird && sizeThird.value !== '') {
        selected_second = parseInt(sizeThird.value);
        const au_size = _sizelist[selected_first][selected_second];
        const result = au_size - 4; 
        container.querySelector('.customers-size').textContent = `US ${result}`;
        third_frame.classList.remove('active');
        fourth_frame.classList.add('active');
        console.log(result);
      }
    });

    reset_frame_button?.addEventListener('click', function() {
      fourth_frame.classList.remove('active');
      first_frame.classList.add('active');
    });

    if (add_to_cart_button) {
      add_to_cart_button.addEventListener('click', function() {
        const result = _sizelist[selected_first][selected_second];

        container.classList.remove('active');
        fourth_frame.classList.remove('active');
        first_frame.classList.add('active');

        document.querySelector('[name="options[Size]"]').value = result;
        document.querySelector('.additional-options').value = result;

        const variant_picker = document.querySelector('.additional-options');
        const variant_picker_id = variant_picker.options[variant_picker.selectedIndex].getAttribute('id');

        document.querySelector('.product__info-wrapper .product-variant-id').value = variant_picker_id;
        document.querySelector('.product__info-wrapper .product-form__submit').click();

        const popup_btn = document.querySelector(".product_find_size");
        popup_btn.classList.add("hidden");
        document.body.classList.remove("no-scroll");

        console.log("Added to cart for section:", container);
      });
    }

  });

});
